export default __webpack_public_path__ + "static/media/arrow-left.0f40a233.webp";